import { Component, Input } from '@angular/core';
import { IOperationsDetails, TitleDetails } from 'app/models/report-details.models';
import { cells, dateCells } from 'app/constants/user-details.constants';
import moment from 'moment';
import { NgFor } from '@angular/common';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  imports: [NgFor],
})
export class UserDetailsComponent {
  detailsList: TitleDetails[] = [];

  @Input() set userDetails(details: IOperationsDetails | null) {
    if (details === null) return;

    const newDetailsList = [];

    for (const cell of cells) {
      const cellValue = details[cell.name as keyof IOperationsDetails];
      const value =
        cellValue && dateCells.includes(cell.name)
          ? moment(cellValue).format('MM/DD/YYYY hh:mm A')
          : cellValue && dateCells.includes(cell.name)
            ? moment.utc(cellValue).local().format('MM/DD/YYYY hh:mm A')
            : cellValue;

      newDetailsList.push({
        title: cell.title,
        text: String(value),
      });
    }
    this.detailsList = newDetailsList;
  }
}
